/**
 * Route for `igaming-pricing-separate-fully-custom`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingPricingSeparateFullyCustomPage } from "../features/igaming-pricing-separate-fully-custom/IgamingPricingSeparateFullyCustomPage";

export const igamingPricingSeparateFullyCustomRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-pricing-separate-fully-custom",
	component: IgamingPricingSeparateFullyCustomPage,
});

export default igamingPricingSeparateFullyCustomRoute;
